module.exports = __webpack_public_path__ + "static/media/plantar-fascitiis.6d83f78d.jpg";